import { PresentationType } from '../../../../../../samwebDescription/samweb/settings/presentationType';

export class ChangeToolbarPresentation {
   public static readonly type = '[ToolbarBrickSettings] Change Toolbar Presentation';

   constructor(public brickInstanceId: string, public presentationType: PresentationType) {}
}

export class ChangeShowVertical {
   public static readonly type = '[ToolbarBrickSettings] Set Toolbar Orientation';

   constructor(public brickInstanceId: string, public showVertical: boolean) {}
}
